<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title
      >{{ tipo == 'E' ? ('Entrada' | translate) : ('Saída' |
      translate)}}</ion-title
    >
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <form
    class="sample-form validations-form"
    [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)"
  >
    <div>
      <ion-card-content class="remove-border">
        <ion-item lines="none">
          <ion-input
            labelPlacement="stacked"
            type="decimal"
            formControlName="valor"
            (ionInput)="formatValor($event)"
            placeholder="{{'Digite o Valor' | translate}}"
            ><div slot="label">
              {{'Valor' | translate}} <ion-text color="danger">*</ion-text>
            </div></ion-input
          >
        </ion-item>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of validation_messages.valor">
            <div
              class="error-message"
              *ngIf="validations_form.get('valor')?.hasError(validation.type) && (validations_form.get('valor')?.dirty || validations_form.get('valor')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>

        <ng-container>
          <prover-datepicker
            [labelName]="'Data do Lançamento'"
            [id]="'data'"
            formControlName="data"
            [required]="true"
          ></prover-datepicker>

          <div class="validation-errors ion-margin-start">
            <ng-container *ngFor="let validation of validation_messages.data">
              <div
                class="error-message"
                *ngIf="validations_form.get('data')?.hasError(validation.type) && (validations_form.get('data')?.dirty || validations_form.get('data')?.touched)"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </ng-container>

        <ion-item>
          <ion-select
            labelPlacement="stacked"
            interface="action-sheet"
            cancelText="{{ 'Cancelar' | translate}}"
            okText="{{ 'Confirmar' | translate}}"
            formControlName="item"
            placeholder="{{'Selecione' | translate}}"
          >
            <div slot="label">
              {{'Tipo do Lançamento' | translate}}
              <ion-text color="danger">*</ion-text>
            </div>

            <ion-select-option *ngFor="let item of itens" [value]="item.id"
              >{{item.nome}}</ion-select-option
            >
          </ion-select>
        </ion-item>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of validation_messages.item">
            <div
              class="error-message"
              *ngIf="validations_form.get('item')?.hasError(validation.type) && (validations_form.get('item')?.dirty || validations_form.get('item')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>

        <ion-item lines="none">
          <ion-textarea
            label="{{'Descrição' | translate}}"
            labelPlacement="stacked"
            rows="3"
            formControlName="descricao"
            placeholder="{{'Digite a Descrição' | translate}}"
          ></ion-textarea>
        </ion-item>

        <ion-item class="switcher-item">
          <ion-toggle
            [enableOnOffLabels]="true"
            class="bold-1"
            justify="space-between"
            [(ngModel)]="vincularPessoa"
            (ionChange)="changeVincular();"
            [checked]="vincularPessoa"
            formControlName="idPessoa"
          >
            {{'Vincular pessoa' | translate}}
          </ion-toggle>
        </ion-item>

        <ion-item *ngIf="pessoa.id">
          <ion-avatar slot="start">
            <img [src]="pessoa.foto | image:' '" />
          </ion-avatar>

          <ion-label>
            <h3 class="item-title bold-2">{{pessoa.nome}}</h3>
          </ion-label>
        </ion-item>

        <div class="down">
          <ion-button
            class="btn-success"
            expand="block"
            type="submit"
            [disabled]="!validations_form.valid || isSubmitting"
          >
            {{'Salvar' | translate}}
          </ion-button>
        </div>
      </ion-card-content>
    </div>
  </form>
</ion-content>
